
export const WHATSAPP_NUMBER = "5545998203513";
export const WHATSAPP_DISPLAY = "(45) 99820-3513";
export const INSTAGRAM_URL = "https://www.instagram.com/guiamagnusmaximo?stkn=Y3AzMDJkYXkyYml1";
export const INSTAGRAM_HANDLE = "@guiamagnusmaximo";
export const FACEBOOK_URL = "https://www.facebook.com/share/1HvMmxHhMF/?mibextid=wwXIfr";
export const GUIDE_NAME = "Magnus Máximo";

export const wa = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT = wa(
  "Olá, Magnus! Quero planejar minha viagem para Foz do Iguaçu."
);

export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Passeios", href: "/passeios" },
  { label: "Sobre o Magnus", href: "#sobre" },
  { label: "Transporte", href: "#transporte" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "FAQ", href: "#faq" },
];

const px = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const asset = (p) =>
  `https://customer-assets-7cd3h4nn.emergentagent.net/job_cataratas-experienza/artifacts/${p}`;

export const IMG = {
  hero: px(1232766, 2000),
  cataratasBrasil: asset("suy8lo0y_6ccd9bf7-6d89-4a75-b6fd-7c007a72740a.webp"),
  cataratasArgentina: asset("nat2olhn_Mask-group-28.png"),
  paraguai: asset("0owd35ar_ciudad-del-este-cidade-do-leste.webp"),
  argentina:
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=1400&auto=format&fit=crop",
  triplice: asset("hjp0spd9_Obelisco-marco-das-3-frotneiras-1024x768.jpg"),
  van: "https://customer-assets-7cd3h4nn.emergentagent.net/job_cataratas-experienza/artifacts/duqefrxp_WhatsApp%20Image%202026-09-11%20at%2009.12.34.jpeg",
  vanSeats: "https://images.pexels.com/photos/39416592/pexels-photo-39416592.png?auto=compress&cs=tinysrgb&w=1000",
  macuco: asset("crkuifs2_macuco-safari-foz-scaled.webp"),
  parqueAves: asset("k0ygtb8g_Viveiro_Aves_de_Rios_e_Mangues.webp"),
  templo: asset("t57zxgn0_templo-budista-em-foz-do-iguacu.jpg"),
  fozAerea: asset("0wqxihu2_foz-do-iguacu-aerea-0001.jpg"),
  cdeAerea: asset("5wn8elgi_imagem_destaque_7071-qpw664zlb51oskq4lh6pponzbaokkv9cc88roe3cyg.jpeg"),
  puertoIguazu: asset("8km0g6xr_images.jpeg"),
  ruinas: asset("txxke785_images.jpeg"),
};

export const PASSEIOS_DETALHE = [
  {
    slug: "cataratas-do-iguacu-brasil",
    flag: "🇧🇷",
    num: "01",
    title: "Cataratas do Iguaçu – Brasil",
    seoTitle: "Passeio nas Cataratas do Iguaçu (Lado Brasil) | Magnus Máximo — Guia em Foz",
    seoDesc: "Conheça o lado brasileiro das Cataratas do Iguaçu com guia local: trilhas, mirantes e a vista mais famosa das quedas. Transporte em Sprinter saindo de Foz do Iguaçu.",
    img: IMG.cataratasBrasil,
    cardDesc: "Uma das maiores maravilhas naturais do mundo. Conheça o lado brasileiro das Cataratas do Iguaçu, com trilhas, mirantes e uma vista privilegiada das impressionantes quedas d'água.",
    cta: "Quero conhecer as Cataratas do Iguaçu (lado Brasil)",
    intro: "O lado brasileiro das Cataratas do Iguaçu oferece a vista panorâmica mais famosa do parque: é daqui que saem aquelas fotos com o conjunto completo das quedas ao fundo. A trilha das Cataratas percorre cerca de 1,2 km de passarelas e mirantes, sempre de frente para as quedas, até chegar ao ponto mais emocionante do passeio.",
    experiencias: [
      "Trilha das Cataratas com paradas nos melhores mirantes para fotos",
      "Passarela que avança sobre o rio, de frente para a Garganta do Diabo",
      "Elevador panorâmico com vista completa do canyon das quedas",
      "Contato com a fauna do Parque Nacional: quatis, tucanos e borboletas",
    ],
    infos: [
      { label: "Duração média", value: "Meio período" },
      { label: "Saída", value: "Hotéis de Foz do Iguaçu" },
      { label: "Transporte", value: "Sprinter para até 18 passageiros" },
      { label: "Acompanhamento", value: "Guia com +15 anos de região" },
    ],
    dica: "Leve protetor solar, água e uma capa de chuva ou roupa leve — a névoa das quedas molha mesmo nos dias de sol. Eu ajudo com todas as orientações antes do passeio.",
  },
  {
    slug: "cataratas-do-iguacu-argentina",
    flag: "🇦🇷",
    num: "02",
    title: "Cataratas do Iguaçu – Argentina",
    seoTitle: "Passeio nas Cataratas Argentinas (Puerto Iguazú) | Magnus Máximo",
    seoDesc: "Passeio completo no lado argentino das Cataratas do Iguaçu: Circuito Superior, Inferior e Garganta del Diablo. Saída de Foz do Iguaçu com transporte e guia.",
    img: IMG.cataratasArgentina,
    cardDesc: "Explore o lado argentino das Cataratas e tenha uma experiência ainda mais próxima da natureza. O passeio conta com diferentes trilhas e mirantes, proporcionando vistas incríveis das quedas.",
    cta: "Quero conhecer as Cataratas Argentinas",
    intro: "Se o lado brasileiro mostra o panorama, o lado argentino coloca você dentro do parque: são passarelas que passam por cima e por baixo das quedas, em meio à selva missioneira. O passeio é mais longo e rende um dia inteiro de experiência, incluindo a impressionante Garganta del Diablo, a maior queda do parque.",
    experiencias: [
      "Garganta del Diablo: passarela de 1,1 km sobre o rio até a maior queda",
      "Circuito Superior com vistas do topo das quedas",
      "Circuito Inferior, caminhando ao lado e por baixo das quedas",
      "Trem Ecológico da Selva e estrutura completa do parque",
    ],
    infos: [
      { label: "Duração média", value: "Dia inteiro" },
      { label: "Fronteira", value: "Cruzamos juntos, com orientação completa" },
      { label: "Documentos", value: "RG original ou passaporte" },
      { label: "Transporte", value: "Sprinter para até 18 passageiros" },
    ],
    dica: "Use calçado confortável e leve pesos em pesos argentinos ou cartão para lanches dentro do parque. Cuido de toda a logística da fronteira para você não se preocupar com nada.",
  },
  {
    slug: "compras-no-paraguai",
    flag: "🇵🇾",
    num: "03",
    title: "Compras no Paraguai",
    seoTitle: "Compras no Paraguai (Ciudad del Este) saindo de Foz | Magnus Máximo",
    seoDesc: "Passeio de compras em Ciudad del Este com transporte e orientação: principais shoppings e lojas confiáveis, cota de isenção e toda a praticidade saindo de Foz do Iguaçu.",
    img: IMG.paraguai,
    cardDesc: "Aproveite sua viagem para fazer compras no Paraguai. Conheça os principais centros comerciais e tenha praticidade e segurança para aproveitar as melhores opções de produtos e lojas da região.",
    cta: "Quero fazer compras no Paraguai",
    intro: "Ciudad del Este é um dos maiores centros de compras da América do Sul e está a menos de uma hora de Foz do Iguaçu. Eletrônicos, perfumes, cosméticos, bebidas e utilidades com preços bem diferentes do Brasil — o segredo é saber onde comprar com segurança.",
    experiencias: [
      "Roteiro pelos principais shoppings e lojas confiáveis da cidade",
      "Orientação sobre cota de isenção e limites de compras na volta ao Brasil",
      "Paradas estratégicas para aproveitar o melhor de cada loja",
      "Possibilidade de combinar com gastronomia e pontos turísticos",
    ],
    infos: [
      { label: "Duração média", value: "Meio período ou dia inteiro" },
      { label: "Documentos", value: "RG original ou passaporte" },
      { label: "Cota de isenção", value: "Orientação atualizada durante o passeio" },
      { label: "Transporte", value: "Sprinter para até 18 passageiros" },
    ],
    dica: "Evite trocar dinheiro na rua e desconfie de preços bons demais. Com um guia ao lado, você compra nas lojas certas e volta tranquilo para o Brasil.",
  },
  {
    slug: "city-tour-argentina",
    flag: "🇦🇷",
    num: "04",
    title: "City Tour e Passeios na Argentina",
    seoTitle: "City Tour em Puerto Iguazú e Passeios na Argentina | Magnus Máximo",
    seoDesc: "City tour completo na Argentina saindo de Foz do Iguaçu: Puerto Iguazú, marco das três fronteiras, gastronomia, vinhos e cultura. Transporte e guia local.",
    img: IMG.puertoIguazu,
    cardDesc: "Conheça os principais pontos turísticos da Argentina em um passeio completo. Explore a região, conheça seus atrativos, gastronomia e cultura, tornando sua viagem ainda mais especial.",
    cta: "Quero fazer o City Tour na Argentina",
    intro: "Puerto Iguazú vai muito além das Cataratas: é uma cidade charmosa, com ótima gastronomia, adegas de vinho, feirinhas de artesanato e o famoso Hito Tres Fronteras, de onde se vê o encontro dos três países. Um passeio perfeito para o fim de tarde.",
    experiencias: [
      "Hito Tres Fronteras: o marco argentino com vista para Brasil e Paraguai",
      "Centro de Puerto Iguazú e feira de artesanato local",
      "Adegas e lojas de vinhos argentinos com preços especiais",
      "Experiências gastronômicas: parrillas, empanadas e o famoso doce de leite",
    ],
    infos: [
      { label: "Duração média", value: "Meio período (ideal no fim de tarde)" },
      { label: "Documentos", value: "RG original ou passaporte" },
      { label: "Saída", value: "Hotéis de Foz do Iguaçu" },
      { label: "Transporte", value: "Sprinter para até 18 passageiros" },
    ],
    dica: "Esse passeio combina muito bem com o jantar: posso sugerir restaurantes e parrillas testados e aprovados por grupos anteriores.",
  },
];

export const EXPERIENCIAS = [
  {
    slug: "cataratas-brasil",
    flag: "🇧🇷",
    tag: "Cataratas do Iguaçu — Brasil",
    title: "Sinta a força das Cataratas",
    desc: "Uma das maiores maravilhas naturais do mundo. Sinta de perto a força das Cataratas do Iguaçu e aproveite uma das experiências imperdíveis da sua viagem.",
    cta: "Quero conhecer as Cataratas",
    img: IMG.cataratasBrasil,
  },
  {
    slug: "cataratas-argentina",
    flag: "🇦🇷",
    tag: "Cataratas do Iguaçu — Argentina",
    title: "O lado argentino das quedas",
    desc: "Uma experiência completamente diferente. Explore os circuitos das Cataratas Argentinas e chegue ainda mais perto das quedas d'água.",
    cta: "Quero conhecer as Cataratas Argentinas",
    img: IMG.cataratasArgentina,
  },
  {
    slug: "paraguai",
    flag: "🇵🇾",
    tag: "Paraguai",
    title: "Compras e gastronomia no Paraguai",
    desc: "Compras, gastronomia e uma experiência diferente da Tríplice Fronteira. Vá ao Paraguai com transporte e orientação para aproveitar melhor seu dia.",
    cta: "Quero ir ao Paraguai",
    img: IMG.paraguai,
  },
  {
    slug: "argentina",
    flag: "🇦🇷",
    tag: "Argentina",
    title: "Muito além das Cataratas",
    desc: "Descubra restaurantes, vinhos, gastronomia e experiências argentinas durante sua estadia em Foz.",
    cta: "Quero conhecer a Argentina",
    img: IMG.argentina,
  },
  {
    slug: "triplice-fronteira",
    flag: "🇧🇷🇦🇷🇵🇾",
    tag: "Tríplice Fronteira",
    title: "Três países em uma única viagem",
    desc: "Brasil, Argentina e Paraguai estão aqui, separados por poucos quilômetros. Viva a região completa em um só roteiro.",
    cta: "Quero conhecer a Tríplice Fronteira",
    img: IMG.triplice,
  },
];

export const DIFERENCIAIS = [
  { icon: "Compass", title: "Mais de 15 anos de experiência", desc: "Conhecimento da região e experiência para ajudar você a aproveitar melhor sua viagem." },
  { icon: "CarFront", title: "Transporte confortável", desc: "Sprinter com capacidade para até 18 passageiros, ideal para famílias e grupos." },
  { icon: "MapPin", title: "Conhecimento local", desc: "Você estará acompanhado por quem conhece Foz do Iguaçu e a Tríplice Fronteira." },
  { icon: "HeartHandshake", title: "Atendimento próximo", desc: "Cada grupo possui suas necessidades. Por isso, o atendimento é personalizado." },
  { icon: "Globe2", title: "Tríplice Fronteira", desc: "Brasil, Argentina e Paraguai em uma mesma experiência." },
];

export const DEPOIMENTOS = [
  { name: "Mariana S.", from: "São Paulo, SP", text: "O Magnus fez nossa viagem ficar perfeita. Conhece cada detalhe da região e cuidou de tudo com muito carinho." },
  { name: "Carlos e Patrícia", from: "Belo Horizonte, MG", text: "Atendimento excelente do início ao fim. A Sprinter é super confortável e os passeios foram impecáveis." },
  { name: "Família Rocha", from: "Curitiba, PR", text: "Viajar com crianças pode ser desafiador, mas com o Magnus tudo fluiu com leveza. Recomendamos demais!" },
  { name: "Diego A.", from: "Buenos Aires, AR", text: "Conocer las Cataratas con quien realmente entiende del destino cambia todo. Una experiencia única." },
  { name: "Fernanda L.", from: "Rio de Janeiro, RJ", text: "Do Macuco Safari às compras no Paraguai, cada dia foi perfeito. O suporte pelo WhatsApp fez toda a diferença." },
  { name: "Grupo Amigos do Sul", from: "Porto Alegre, RS", text: "Dezoito amigos, três países e zero preocupação. Voltamos com a sensação de ter vivido algo único." },
];

export const GALLERY = [
  { img: IMG.cataratasBrasil, alt: "Cataratas do Iguaçu, lado brasileiro" },
  { img: IMG.macuco, alt: "Macuco Safari chegando perto das quedas" },
  { img: IMG.parqueAves, alt: "Tucano no Parque das Aves" },
  { img: IMG.triplice, alt: "Marco das Três Fronteiras ao entardecer" },
  { img: IMG.puertoIguazu, alt: "Letreiro IGUAZÚ em Puerto Iguazú, Argentina" },
  { img: IMG.paraguai, alt: "Compras em Ciudad del Este, Paraguai" },
  { img: IMG.templo, alt: "Templo Budista de Foz do Iguaçu" },
  { img: IMG.ruinas, alt: "Ruínas jesuitas na região da Tríplice Fronteira" },
  { img: IMG.cdeAerea, alt: "Ponte da Amizade entre Brasil e Paraguai" },
];

export const FAQ = [
  { q: "Quantas pessoas cabem na Sprinter?", a: "Nossa Sprinter possui capacidade para até 18 passageiros, com conforto para famílias, grupos de amigos e excursões." },
  { q: "Você trabalha com passeios na Argentina?", a: "Sim. Atendo turistas que desejam conhecer as Cataratas Argentinas e outras experiências na Argentina, como restaurantes e vinícolas." },
  { q: "Você faz transporte para o Paraguai?", a: "Sim. Levo grupos para compras e gastronomia em Ciudad del Este, com orientação durante todo o dia. Consulte disponibilidade e condições para o seu grupo." },
  { q: "Posso contratar para minha família?", a: "Sim. O atendimento é personalizado de acordo com o tamanho e as necessidades do seu grupo — de casais a excursões completas." },
  { q: "Você faz transfer?", a: "Sim. Faço transfers entre aeroporto, hotéis, atrativos turísticos e destinos da Tríplice Fronteira (Brasil, Argentina e Paraguai)." },
  { q: "Preciso reservar antecipadamente?", a: "Recomendo entrar em contato com antecedência para consultar a disponibilidade para a data da sua viagem, principalmente em feriados e alta temporada." },
];
